/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: contacts-list-component.ts
 *
 * Created by randysorensen on 6/4/18.
 */

function ContactsListController(this: JS5Object,
                                       _: JS5Object,
                                       $timeout: JS5Function,
                                       uiGridConstants: JS5Object,
                                       ModalService: JS5Object) {

    const getContactsList = () => {
        let contactsList;
        if (this.modelProp) {
            contactsList = _.get(this.ngModel, this.modelProp);
        } else {
            contactsList = _.get(this, 'ngModel');
        }
        return contactsList;
    };

    const initGrid = () => {
        this.gridOptions = {
            rowSelection: true,
            enableRowHeaderSelection: false,
            enableSelectAll: true,
            enableColumnResizing: true,
            enablePaginationControls: false,
            enableSorting: true,
            enableColumnMenus: false,
            enableFullRowSelection: true,
            enableHorizontalScrollbar: uiGridConstants.ALWAYS,
            enableVerticalScrollbar: uiGridConstants.ALWAYS,
            multiSelect: true,
            onRegisterApi: (gridApi: JS5Object) => {
                this.gridApi = gridApi;
            },
            rowTemplate: 'components/visual/grid/searchview-component-row-template.html'
        };

        this.gridOptions.columnDefs = [
            {
                name: 'checkMarkRowHeaderCol',
                field: 'checkMark',
                width: 30,
                enableSorting: false,
                enableColumnResizing: false,
                headerCellTemplate: 'components/visual/grid/header-check-mark-component-template.html',
                cellTemplate: 'components/visual/grid/check-mark-template.html'
            },
            {
                field: 'firstName',
                type: 'string',
                width: '25%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 2
                },
                displayName: 'First Name',
            },
            {
                field: 'lastName',
                type: 'string',
                width: '25%',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 1
                },
                displayName: 'Last Name',
            },
            {
                field: 'emailAddress',
                type: 'string',
                width: '*',
                enableColumnResizing: true,
                sort: {
                    direction: uiGridConstants.ASC,
                    priority: 3
                },
                displayName: 'Email Address',
            }];
    };

    this.onSelectAllToggled = ($event: JS5Object) => {
        if (this.gridApi.selection.getSelectAllState()) {
            this.gridApi.selection.clearSelectedRows();
        } else {
            this.gridApi.selection.selectAllRows();
        }
    };

    const contactsSelected = (selectedContacts: JS5Object) => {
        _.forEach(selectedContacts, (contact: JS5Object) => {
            // at least one contact added - dirty the form
            this.editorForm.$setDirty();
            getContactsList().push(contact);
        });
    };

    this.onAddContactsClick = ($event: JS5Object) => {
        const existingContactIds: number[] = _.map(getContactsList(), 'id');
        ModalService.showContactsSelectModal(existingContactIds, contactsSelected);

        // defocus button
        $event.target.blur();
    };

    this.onRemoveContactsClick = ($event: JS5Object) => {
        const selectedContacts = this.gridApi.selection.getSelectedRows();
        _.forEach(selectedContacts, (contact: JS5Object) => {
            this.gridApi.selection.unSelectRow(contact);

            // at least one contact removed - dirty the form
            this.editorForm.$setDirty();

            _.remove(getContactsList(), contact);
        });

        // defocus button
        $event.target.blur();
    };

    const assignGridData = () => {
        if (_.isNil(getContactsList())) {
            if (this.modelProp) {
                _.set(this, `ngModel.${this.modelProp}`, []);
            } else {
                _.set(this, 'ngModel', []);
            }
        }

        _.set(this, 'gridOptions.data', getContactsList());
    };

    this.$onInit = () => {
        initGrid();
    };

    this.$onChanges = () => {
        assignGridData();
    };

}

angular.module('prism-ui.components').component(
    'contactsList',
    {
        controller: ContactsListController,
        templateUrl: 'components/visual/contactsList/contacts-list-template.html',
        bindings: {
            ngModel: '<',
            modelProp: '<'
        }
    });
